/**
 * Created by chenzheyu on 2017/6/16.
 */
import XKmodalMod from './src/modalMod.vue'

XKmodalMod.intall = function (Vue) {
  Vue.component(XKmodalMod.anme, XKmodalMod)
}

export default XKmodalMod



// WEBPACK FOOTER //
// ./src/components/module/modalMod/index.js